// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { ListingCard_ListingFragment } from "@outschool/gql-frontend-generated";
import {
  CurvedGradientSection,
  PageWidthSection
} from "@outschool/ui-legacy-component-library";
import React from "react";

import ListingCarousel from "../../components/listings/carousels/ListingCarousel";

export default function UpsellCarouselMagnetPage({
  title,
  listings
}: {
  title?: string;
  listings: ListingCard_ListingFragment[];
}) {
  if (!listings) {
    return <></>;
  }

  const cleanListings = listings.map(el => {
    return {
      __typename: "Listing",
      leader: el.leader,
      activity: el.activity,
      sectionCount: el.sectionCount,
      openSectionCount: el.openSectionCount,
      upcomingSectionCount: el.upcomingSectionCount
    } as ListingCard_ListingFragment;
  });

  return (
    <CurvedGradientSection>
      <PageWidthSection>
        <ListingCarousel
          sx={{
            color: "#23055b", // primary.900
            paddingLeft: "0",
            width: "100%"
          }}
          alwaysShown
          listings={cleanListings}
          carouselRowNum={1}
          title={title}
          trackingLabel="magnet_page_upsell_class_carousel"
        />
      </PageWidthSection>
    </CurvedGradientSection>
  );
}
